export default "__VITE_ASSET__d4915a02__"